import { reduce, snakeCase } from "@s-libs/micro-dash";

type ConvertObjectKeysToSnakeCase = (
  object: Record<string, unknown>,
) => Record<string, unknown>;

const convertObjectKeysToSnakeCase: ConvertObjectKeysToSnakeCase = (object) => {
  return reduce(
    object,
    (acc, value, key) => ({ ...acc, [snakeCase(key)]: value }),
    {},
  );
};

export default convertObjectKeysToSnakeCase;
